import { useSelector } from "react-redux";
import ServiceProviderFilter from "./ServiceProviderFilter";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import {
  btnAccessChecker,
  checkButtonAccess,
} from "../../../Utils/CommonUtils";
import useServiceProviderColumns from "./Hooks/useServiceProviderColumns";
import {
  setPspFilterForm,
  setPspSorting,
  setServiceProviderData,
} from "../../../slices/psp/serviceProvider/reducer";
import {
  getFilteredDataWithTabs,
  getListing,
} from "../../../Utils/CommonService";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { useEffect } from "react";
import { resetFormState } from "../../../slices/common/reducer";
import { useDispatch } from "react-redux";

const ServiceProviderList = () => {
  const dispatch = useDispatch();
  const { serviceProviderColumns } = useServiceProviderColumns();

  const serviceProviderData = useSelector(
    (state) => state.serviceProvider.serviceProviderData
  );

  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);
  const filterApi = useSelector(
    (state) => state.serviceProvider.filter.filterApi
  );
  const filterFormCopy = useSelector(
    (state) => state.serviceProvider.filter.formCopy
  );
  const filterForm = useSelector((state) => state.serviceProvider.filter.form);
  const sortColumn = useSelector(
    (state) => state.serviceProvider.sorting.column
  );
  const sortOrder = useSelector((state) => state.serviceProvider.sorting.order);

  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");

  useEffect(() => {
    dispatch(resetFormState());
    dispatch(setPspFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        title={"All PSP"}
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "PSP_PSP")}
        formLink="/psp/psp/create"
        deletebtn={true}
        buttonTitle={"New PSP"}
        filterComponent={<ServiceProviderFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={serviceProviderColumns}
          data={serviceProviderData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"PSP"}
          filterApiListEntity={"PSP"}
          filterApiFunction={setServiceProviderData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setPspSorting}
          enterpriseId={enterpriseid}
          userId={userid}
          organizationType="PSP"
        />
      </div>
    </div>
  );
};

export default ServiceProviderList;
